import { BRANDS } from "./brands";
import { Hero } from "./components/Hero";
import { BrandTile } from "./components/BrandTile";
import { Edge } from "./components/Edge";
import { Footer } from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Hero />

      <main id="brands" className="mx-auto w-full max-w-6xl px-6 py-16 flex-1">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-jw-chrome-dim">
              Four Public Engines
            </p>
            <h2 className="mt-2 font-display text-2xl sm:text-3xl text-jw-chrome-bright tracking-tight">
              Where to find the work.
            </h2>
          </div>
          <div className="hidden sm:block jw-rule max-w-[280px] mb-2" />
        </div>

        <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {BRANDS.map((b) => (
            <BrandTile key={b.id} brand={b} />
          ))}
        </div>

        <p className="mt-12 text-sm text-jw-text-subtle max-w-xl leading-relaxed">
          The parent identity is meta to the four product brands — it shows what
          makes the system possible. Each engine has its own audience and
          product; underneath, they share the same operator and the same loop:
          observe, build, improve, document, automate, scale, compound.
        </p>

        <Edge />
      </main>

      <Footer />
    </div>
  );
}
